// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__XlgsM","label":"Radio_label__2mCei","checkMark":"Radio_checkMark__2ZGg9","disabled":"Radio_disabled__2_ZAw"};